import { Portal } from '@angular/cdk/portal';
import { Component, Input, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SiteSidenavService } from '../site-sidenav/site-sidenav.service';

@Component({
    selector: 'ndt-site-sidenav-content',
    templateUrl: './site-sidenav-content.component.html',
    standalone: false
})
export class SiteSidenavContentComponent<T> implements OnInit {
   @Input() position: 'start' | 'end';

   portal$: Observable<Portal<T> | null>;

   constructor(private siteSidenavService: SiteSidenavService, public sidenav: MatSidenav) {}

   ngOnInit(): void {
      this.portal$ = this.siteSidenavService.siteSidenavPortal(this.position).pipe(
         filter((x) => {
            return x === null || x.position === this.position;
         })
      );
   }
}
